import {GET_ALLCURRENCY_FAILED, GET_ALLCURRENCY_LOADING, GET_ALLCURRENCY_SUCCESS } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    Countries: null,
  };
  
  export const getAllCurrencyReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_ALLCURRENCY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_ALLCURRENCY_SUCCESS:
        return {
          ...state,
          loading: false,
          Countries: action.payload,
          error: null,
        };
      case GET_ALLCURRENCY_FAILED:
        return {
          ...state,
          loading: false,
          Countries: null,
          error: action.error,
        };
      default:
        return state;
    }
  };
  